const enum WidgetAttributes {
  WIDGET_SPORT = 'data-widget-sport',
  WIDGET_TYPE = 'data-widget-type',
  WIDGET_ID = 'data-widget-id',
  DATE = 'data-date',
  NAME_TYPE = 'data-team-name-type',
  REFRESH_TIME = 'data-refresh-time',
  ENTITY_LINKS = 'data-entity-links',
  THEME = 'data-theme',
  POPULAR_LIST = 'data-popular-list',
  LABELS = 'data-labels',
  DROPDOWN_DISPLAY = 'data-dropdown-display',
  HEADER_DEFAULT_OPTION = 'data-header-default-option',
  HEADER_DISPLAY = 'data-header-display',
  ODDS_BETTING_ID = 'data-odds-betting-id',
  ODDS_DISPLAY = 'data-odds-display',
  ODDS_MARKET = 'data-odds-market',
  ODDS_PRE_EVENT_ONLY = 'data-odds-pre-event-only',
  ODDS_MARKET_VALUE_TYPE = 'data-odds-market-value-type',
  OPTIONS_DISPLAY = 'data-options-display',
  ODDS_TAB_BETTING_ID = 'data-odds-tab-betting-id',
  AGE_RESTRICTION_DISPLAY = 'data-age-restriction-display',
  MATCH = 'data-match-id',
  SHORT_STATUS_TYPE = 'data-short-status-type',
  COMPETITION = 'data-competition',
  STAGE = 'data-stage',
  SEASON = 'data-season',
  PLAYER = 'data-player',
  TEAM = 'data-team',
  TABS = 'data-tabs',
  DISPLAY_TABS = 'data-display-tabs',
  DEFAULT_TAB = 'data-default-tab',
  ROUND = 'data-round',
  ROUNDS = 'data-rounds',
  ROUNDS_FILTER = 'data-rounds-filter',
  MATCH_TYPE = 'data-match-type',
  SORT_DIRECTION = 'data-sort-direction',
  SORT_DIRECTION_RESULTS = 'data-sort-direction-results',
  SORT_DIRECTION_FIXTURES = 'data-sort-direction-fixtures',
  FANS_UNITED_API_KEY = 'fans-united-api-key',
  FANS_UNITED_CLIENT_ID = 'fans-united-client-id',
  FANS_UNITED_EXPANDED = 'fans-united-expanded',
  FANS_UNITED_TOKEN = 'fans-united-token',
  FANS_UNITED_ID_SCHEMA = 'fans-united-id-schema',
  FANS_UNITED_ENABLED = 'fans-united-enabled',
  FANS_UNITED_ENVIRONMENT = 'fans-united-environment',
  FANS_UNITED_HIDE_BEFORE_GAME_START = 'fans-united-hide-before-game-start',
  FANS_UNITED_SHOW_FROM = 'fans-united-show-from',
  GROUPS = 'data-groups',
  DISPLAY_STATISTICS = 'data-display-statistics',
  LIMIT = 'data-limit',
  DATA_TEAM_IDS = 'data-team-ids',
  DATA_LIMIT = 'data-limit',
  DATA_START_POSITION = 'data-start-position',
  DATA_HIGHLIGHT_ENTITIES = 'data-highlight-entities',
  SPORT_ENTITY_ONE = 'data-sport-entity-one',
  SPORT_ENTITY_TWO = 'data-sport-entity-two',
  ELEMENTS = 'data-elements',
  ELEMENTS_MOBILE = 'data-elements-mobile',
  ELEMENTS_DESKTOP = 'data-elements-desktop',
  TEAM_TYPE = 'data-team-type',
  DATA_OFFSET = 'data-offset',
  DATA_STANDING_TYPE_SUBCATEGORY = 'data-standing-type-subcategory',
  TOURNAMENT = 'data-tournament',
  HOME_TEAM_COLOR = 'data-home-team-color',
  AWAY_TEAM_COLOR = 'data-away-team-color',
  ALLOW_INLINE_ODDS = 'data-allow-inline-odds',
  ADDITIONAL_INFO = 'data-additional-info',
  IMAGE_DISPLAY = 'data-image-display',
  AMOUNT = 'data-amount',
  WRAPPER_LINK = 'data-wrapper-link',
  GAME_TYPE = 'data-game-type',
  GENDER = 'data-gender',
  FIXED = 'data-fixed',
  DATA_DATE_FROM = 'data-date-from',
  DATA_DATE_TO = 'data-date-to',
  BETTING_BRAND_COLORS = 'data-betting-brand-colors',
  BETTING_LOGO_CLICK_ACTION = 'data-betting-logo-click-action',
  BETTING_LOGO_OVERLAP = 'data-betting-logo-overlap',
  BETTING_LOGO_DISPLAY = 'data-betting-logo-display',
  DATA_ODDS_CLICKABLE = 'data-odds-clickable',
  DATA_SHOW_COMPETITION_NAMES = 'data-show-competition-names', // only for multisport
  NAME_FORMAT = 'data-name-format',
  COMPETITIONS = 'data-competitions', // only for multisport
  SPORT = 'data-sport', // only for multisport
  DATA_MATCH_DISPLAY = 'data-match-display',
  DATA_STATISTICS_DISPLAY = 'data-statistics-display',
  CURRENCY_POSITION = 'data-currency-symbol-position',
  SINGLE_EVENT_MAIN_EVENTS_DISPLAY = 'data-single-event-main-events-display',
  MATCH_CENTER_EVENT_MAIN_EVENTS_DISPLAY = 'data-match-center-main-events-display',
  DATE_FORMAT = 'data-date-format',
  DATA_DISPLAY_SOCIAL_ICONS = 'data-display-social-icons',
  DATA_DISPLAY_TEAM_IMAGE = 'data-display-team-image',
  DATA_COUNTRY_ID = 'data-country-id',
}

export default WidgetAttributes;
